<template>
  <div class="shop-container">
    <swiper-small :list="bannerArr" />
    <div class="class-list" v-if="gameList.length > 0">
      <!-- <div class="mini-menus">
        <div class="mini-menus-item">
          <div class="mini-menus-item-title"><img src="@/assets/icon/list_logo.png" alt="" />射击竞赛列表</div>
          <img class="right-logo" src="@/assets/icon/enter_logo.png" alt="" />
        </div>
        <div class="mini-menus-item">
          <div class="mini-menus-item-title"><img src="@/assets/icon/list_logo.png" alt="" />射击竞赛列表</div>
          <img class="right-logo" src="@/assets/icon/enter_logo.png" alt="" />
        </div>
        <div class="mini-menus-item">
          <div class="mini-menus-item-title"><img src="@/assets/icon/list_logo.png" alt="" />射击竞赛列表</div>
          <img class="right-logo" src="@/assets/icon/enter_logo.png" alt="" />
        </div>
      </div> -->
      <!-- 推荐赛事 -->
      <div class="class-title">
        {{ "推荐赛事" }}
        <router-link :to="{ name: 'gamelist' }">
          <i>{{ $t("more") }}</i>
        </router-link>
      </div>
      <div class="class-item-wrap">
        <div class="class-item-gameList" v-for="item in gameList" :key="item.id">
          <router-link tag="a" target="_blank" :to="{ name: 'gamedetail', params: { gameId: item.id } }">
            <div class="videp-cover" :style="{ backgroundImage: `url(${item.banner})`, backgroundSize: 'cover' }"></div>
            <div class="text">赛事名称：{{ item.title }}</div>
            <div class="text">报名时间：{{ item.stime + "至" + item.etime }}</div>
            <div class="text">比赛时间：{{ item.gamestime + "至" + item.gameetime }}</div>
            <div class="text">举办地址：{{ item.address }}</div>
            <div class="btns">
              <!-- 赛事分类 -->
              <div v-if="item.status == 2" class="btn-red">立即报名</div>
              <div v-else-if="item.status == 4" class="btn-blueOson">查看成绩</div>
              <div v-else-if="item.status == 3" class="btn-gray">正在比赛</div>
              <div v-else class="btn-blueOson">查看详情</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="class-list" v-if="hot.length > 0">
      <!-- 热门视频 -->
      <div class="class-title">
        {{ "精彩" }}{{ $t("video")
        }}<router-link :to="{ name: 'videoclassify' }">
          <i>{{ $t("more") }}</i>
        </router-link>
      </div>
      <div class="class-item-wrap">
        <div class="class-item" v-for="item in hot" :key="item.id" @click="detail(item)">
          <!-- <img :src="item.cover" alt="" > -->
          <div
            class="videp-cover"
            :style="{
              backgroundImage: `url(${item.cover})`,
              backgroundSize: 'cover',
            }"
          ></div>
          <img v-if="item.price > 0" class="vip" src="@/assets/images/video/vip.png" alt="" />
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperSmall from "@/components/common/SwiperSmall.vue";
export default {
  components: {
    SwiperSmall,
  },
  data() {
    return {
      bannerArr: [],
      loftData: [],
      form: {
        page: 1,
        limit: 10,
        where: {
          is_hot: 1,
        },
      },
      hot: [], // 热门视频
      gameList: [],
      form1: {
        page: 1,
        limit: 10,
        status: 1, //1为全部 2为报名中 3为竞赛中 4为已结束
        type_id: "",
        area_id: "",
        keyword: "",
      },
    };
  },
  mounted() {
    this.getBanner();
    this.list("hot");
    this.getGameList();
  },
  methods: {
    getGameList() {
      this.$api.getList(this.form1).then((res) => {
        if (res.status) {
          this.gameList = res.data.list.slice(0, 4);
        }
      });
    },
    // 获取轮播图s
    getBanner() {
      this.$api
        .slider({
          code: "pc_home_slide",
        })
        .then((res) => {
          if (res.status) {
            this.bannerArr = res.data.list;
          }
        });
    },
    initParams() {
      let copy = JSON.parse(JSON.stringify(this.form));
      copy.where = JSON.stringify(copy.where);
      return copy;
    },
    list(value) {
      let params = this.initParams();
      this.$api.courseGetlist(params).then((res) => {
        this[value] = res.data.list.slice(1, 9);
      });
    },
    detail(item) {
      this.$router.push({
        name: "videodetail",
        params: {
          videoId: item.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.class-list {
  // background: #ffffff;
  width: 1226px;
  margin: 20px auto 0;
  // padding: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.class-title {
  color: #333333;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: inline-block;
    width: 6px;
    height: 38px;
    background: #ff6d6d;
    border-radius: 4px;
    margin-right: 7px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
  }
}
.mini-menus {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  .mini-menus-item {
    display: flex;
    box-sizing: border-box;
    align-items: center;
    align-content: center;
    justify-content: space-between;
    width: 380px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(242, 241, 241, 1);
    padding: 21px 23px;
    .mini-menus-item-title {
      font-size: 14px;
      color: rgba(49, 44, 44, 1);
      text-align: left;
      position: relative;
      display: flex;
      align-content: center;
      align-items: center;
      img {
        width: 18px;
        height: 18px;
        margin-right: 9px;
      }
    }
    .right-logo {
      width: 16px;
      height: 16px;
    }
  }
}
.class-item-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .class-item {
    width: 296px;
    height: 200px;
    margin-top: 20px;
    margin-bottom: 30px;
    margin-left: 13px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    &:hover {
      box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
    }
    &:first-child {
      margin-left: 0;
    }
    &:nth-child(5n) {
      margin-left: 0;
    }
    .videp-cover {
      width: 296px;
      height: 200px;
    }
    .title {
      position: absolute;
      bottom: 0%;
      left: 0%;
      width: 100%;
      height: 50px;
      background: rgba(49, 44, 44, 0.5);
      text-align: center;
      line-height: 50px;
      color: white;
      font-size: 14px;
    }
  }
  .class-item-gameList {
    margin-top: 20px;
    margin-bottom: 10px;
    margin-left: 13px;
    padding: 17px 20px 30px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    border: 1px solid rgba(204, 202, 202, 1);
    background-color: white;
    &:hover {
      //   box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
      box-shadow: 0px 2px 10px rgba(49, 44, 44, 0.2);
      border: 1px solid transparent;
    }
    &:first-child {
      margin-left: 0;
    }
    &:nth-child(6n) {
      margin-left: 0;
    }
    .videp-cover {
      width: 254px;
      height: 200px;
      margin-bottom: 15px;
      // border-radius: 10px;
    }
    .text {
      width: 254px;
      height: 20px;
      opacity: 1;
      /** 文本1 */
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 19.21px;
      color: rgba(49, 44, 44, 1);
      text-align: left;
      vertical-align: top;
      margin-bottom: 12px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      //   @include no-wrap-line(2);
    }
    .btns {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .btn-red {
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        // border-radius: 4px;
        color: white;
        background-color: rgba(231, 68, 47, 1);
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        margin-right: 10px;
      }
      .btn-gray {
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        // border-radius: 4px;
        color: white;
        background-color: #c4c4c4;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        margin-right: 10px;
      }
      .btn-blueOson {
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        // border-radius: 4px;
        color: white;
        background-color: #192742;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        margin-right: 10px;
      }
      .btn {
        width: 60px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        // border-radius: 4px;
        color: rgba(49, 44, 44, 1);
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(204, 202, 202, 1);
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        // margin-right: 10px;
      }
    }
  }
}
</style>
